module.exports = __webpack_public_path__ + "static/media/sidebar-3547b2a0050ac5a652cd7c9d12444e952jpg";